import React from 'react';
import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <section className="text-center max-w-4xl mx-auto px-4 mb-12 md:mb-16">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="inline-flex items-center gap-2 py-2 px-4 md:px-5 rounded-full bg-gradient-badge text-white text-[10px] md:text-xs font-bold mb-6 md:mb-8 uppercase tracking-[0.2em] shadow-lg shadow-brand-pink/20">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
          </span>
          Member Training
        </div>
        
        <h1 className="text-4xl md:text-7xl lg:text-8xl font-bold text-white mb-6 md:mb-8 tracking-tight leading-[1.1]">
          Your <span className="text-transparent bg-clip-text bg-gradient-brand">Selling Trade</span> Guide
        </h1>
        
        <p className="text-base md:text-xl text-text-body mb-10 max-w-2xl mx-auto leading-relaxed px-2">
          Follow our interactive walkthrough to master signal execution, entries, and exits with AI precision.
        </p>

        <div className="flex items-center justify-center gap-6 md:gap-12 pt-4">
          <div className="flex flex-col items-center">
            <span className="text-xl md:text-2xl font-bold text-white">PRO</span>
            <span className="text-[9px] md:text-[10px] text-brand-secondary uppercase tracking-[0.2em] font-bold">Strategy</span>
          </div>
          <div className="w-px h-8 bg-white/10"></div>
          <div className="flex flex-col items-center">
            <span className="text-xl md:text-2xl font-bold text-white">AI</span>
            <span className="text-[9px] md:text-[10px] text-brand-secondary uppercase tracking-[0.2em] font-bold">Signals</span>
          </div>
          <div className="w-px h-8 bg-white/10"></div>
          <div className="flex flex-col items-center">
            <span className="text-xl md:text-2xl font-bold text-white">100%</span>
            <span className="text-[9px] md:text-[10px] text-brand-secondary uppercase tracking-[0.2em] font-bold">Execution</span>
          </div>
        </div>
      </motion.div>
    </section>
  );
}